import { Injectable } from '@angular/core';
import {
  Observable,
  catchError,
  throwError,
  timeout,
} from 'rxjs';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

// const API_URL = `${ENV.API.AFILIACIONES_AFE}`;
const API_URL = `${ENV.HOST}${URL_MAP.API.AFILIACIONES_AFE}`;
// const API_URL_SHAREPOINT = `${ENV.API.AFILIACIONES_SHAREPOINT}`;
const API_URL_SHAREPOINT = `${ENV.HOST}${URL_MAP.API.AFILIACIONES_SHAREPOINT}`;
const TIMEOUT_MS = 15000; // 15 segundos de timeout

@Injectable({
  providedIn: 'root',
})
export class AfiliacionService {
  constructor(private http: HttpClient) {}

  consultarSolicitudesDeAfiliacion(requestBody: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http
      .post<any>(`${API_URL}`, requestBody, { headers })
      .pipe(timeout(TIMEOUT_MS), catchError(this.handleError));
  }

  consultarSolicitudesDeAfiliacionSharePoint(
    requestBody: any
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http
      .post<any>(API_URL_SHAREPOINT, requestBody, { headers })
      .pipe(timeout(TIMEOUT_MS), catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    let mensaje = 'Ha ocurrido un error inesperado.';
    if (error.error instanceof ErrorEvent) {
      // Error del lado del cliente o red
      mensaje = `Error de red o cliente: ${error.error.message}`;
    } else {
      // Error del backend
      switch (error.status) {
        case 400:
          mensaje = 'Solicitud incorrecta.';
          break;
        case 404:
          mensaje = 'Recurso no encontrado.';
          break;
        case 500:
          mensaje = 'Error del servidor.';
          break;
        default:
          mensaje = `Código de error: ${error.status}, mensaje: ${error.message}`;
          break;
      }
    }
    return throwError(() => new Error(mensaje));
  }
}